(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cn-best-sellers]').forEach((section) => {
    if (section.dataset.cnBestSellersReady === 'true') return;
    section.dataset.cnBestSellersReady = 'true';

    const track = section.querySelector('[data-cn-best-sellers-track]');
    const previous = section.querySelector('[data-cn-best-sellers-previous]');
    const next = section.querySelector('[data-cn-best-sellers-next]');
    if (!track || !previous || !next) return;

    const updateButtons = () => {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum;
    };

    const move = (direction) => {
      track.scrollBy({ left: track.clientWidth * 0.82 * direction, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peek-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('peek-slideshow')) {
    customElements.define(
      'peek-slideshow',
      class PeekSlideshow extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';
          this.viewport = this.querySelector('.crystal-peek__viewport');
          this.track = this.querySelector('.crystal-peek__track');
          this.originalSlides = Array.from(this.querySelectorAll('.crystal-peek__slide'));
          this.logicalCount = this.originalSlides.length;
          this.loopEnabled = this.logicalCount > 1;

          if (this.loopEnabled) {
            const lastClone = this.createLoopClone(this.originalSlides[this.logicalCount - 1], 'last');
            const firstClone = this.createLoopClone(this.originalSlides[0], 'first');
            this.track.prepend(lastClone);
            this.track.append(firstClone);
          }

          this.slides = Array.from(this.querySelectorAll('.crystal-peek__slide'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.current = this.querySelector('[data-current]');
          this.toggle = this.querySelector('[data-autoplay-toggle]');
          this.activeIndex = 0;
          this.manualPaused = false;
          this.scrollTimer = null;
          this.interval = null;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.querySelector('[data-previous]')?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.goTo(this.activeIndex + 1));
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dot))));
          this.toggle?.addEventListener('click', () => this.setPaused(!this.manualPaused));

          this.viewport?.addEventListener(
            'scroll',
            () => {
              window.clearTimeout(this.scrollTimer);
              this.scrollTimer = window.setTimeout(() => this.updateFromScroll(), 90);
            },
            { passive: true }
          );

          this.addEventListener('mouseenter', () => this.stopTimer());
          this.addEventListener('mouseleave', () => this.startTimer());
          this.addEventListener('focusin', () => this.stopTimer());
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.startTimer();
          });
          this.addEventListener('shopify:block:select', (event) => {
            const slide = event.target.closest('.crystal-peek__slide');
            if (slide) {
              this.setPaused(true);
              this.goTo(Number(slide.dataset.slideIndex));
            }
          });

          this.setActive(0, this.loopEnabled ? 1 : 0);
          window.requestAnimationFrame(() => this.positionPhysical(this.loopEnabled ? 1 : 0, false));
          this.startTimer();
        }

        disconnectedCallback() {
          this.stopTimer();
          window.clearTimeout(this.scrollTimer);
        }

        createLoopClone(source, position) {
          const clone = source.cloneNode(true);
          clone.classList.remove('is-active');
          clone.dataset.loopClone = position;
          clone.removeAttribute('id');
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          Array.from(clone.attributes).forEach((attribute) => {
            if (attribute.name.startsWith('data-shopify')) clone.removeAttribute(attribute.name);
          });
          clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
            element.setAttribute('tabindex', '-1');
          });
          return clone;
        }

        goTo(index, smooth = true) {
          if (!this.viewport || this.logicalCount === 0) return;
          const logicalIndex = ((index % this.logicalCount) + this.logicalCount) % this.logicalCount;
          let physicalIndex = this.loopEnabled ? logicalIndex + 1 : logicalIndex;

          if (this.loopEnabled) {
            if (index < 0 && this.activeIndex === 0) physicalIndex = 0;
            if (index >= this.logicalCount && this.activeIndex === this.logicalCount - 1) {
              physicalIndex = this.slides.length - 1;
            }
          }

          this.positionPhysical(physicalIndex, smooth);
          this.setActive(logicalIndex, physicalIndex);
        }

        positionPhysical(index, smooth = true) {
          if (!this.viewport || !this.slides[index]) return;
          const slide = this.slides[index];
          const left = slide.offsetLeft - (this.viewport.clientWidth - slide.clientWidth) / 2;
          this.viewport.scrollTo({ left, behavior: smooth && !this.reducedMotion ? 'smooth' : 'auto' });
        }

        updateFromScroll() {
          if (!this.viewport || this.slides.length === 0) return;
          const viewportCenter = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;
          this.slides.forEach((slide, index) => {
            const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
            const distance = Math.abs(slideCenter - viewportCenter);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          const logicalIndex = Number(this.slides[closestIndex].dataset.slideIndex);
          this.setActive(logicalIndex, closestIndex);

          if (this.loopEnabled && closestIndex === 0) {
            this.positionPhysical(this.logicalCount, false);
          }

          if (this.loopEnabled && closestIndex === this.slides.length - 1) {
            this.positionPhysical(1, false);
          }
        }

        setActive(index, physicalIndex = this.loopEnabled ? index + 1 : index) {
          this.activeIndex = index;
          this.slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === physicalIndex));
          this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false'));
          if (this.current) this.current.textContent = String(index + 1);
        }

        setPaused(paused) {
          this.manualPaused = paused;
          this.dataset.paused = paused ? 'true' : 'false';
          if (this.toggle) {
            this.toggle.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
          }
          if (paused) this.stopTimer();
          else this.startTimer();
        }

        startTimer() {
          this.stopTimer();
          if (this.dataset.autoplay !== 'true' || this.manualPaused || this.reducedMotion || this.logicalCount < 2) return;
          this.interval = window.setInterval(() => this.goTo(this.activeIndex + 1), Number(this.dataset.speed) * 1000);
        }

        stopTimer() {
          if (this.interval) window.clearInterval(this.interval);
          this.interval = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-details"] && !Shopify.designMode) return;
  try {
    
function parseCureTimes(source) {
  const text = source.toLowerCase().replace(/[–—−]/g, '-').replace(/\u00a0/g, ' ');
  if (/\b(?:shorter|longer)\s+(?:binding|curing|cure|setting)\s*time.{0,40}\d/.test(text)) return [];
  const number = '(\\d+(?:[.,]\\d+)?)';
  const duration = number + '(?:\\s*(?:-|to)\\s*' + number + ')?\\s*(seconds?|secs?|s\\b|minutes?|mins?|min\\b)';
  const lamp = '(uv\\s*[/+]\\s*led|led\\s*[/+]\\s*uv|uv|led)';
  const patterns = [
    { regex: new RegExp('\\b' + lamp + '\\b\\s*(?:lamps?|lights?)?\\s*(?:for|is|:|=)?\\s*' + duration, 'g'), lamp: 1, low: 2, high: 3, unit: 4 },
    { regex: new RegExp('\\b' + duration + '\\.?\\s*\\(?\\s*(?:(?:in|under|with|using)\\s*)?(?:(?:an?|the)\\s*)?' + lamp + '\\b', 'g'), lamp: 4, low: 1, high: 2, unit: 3 }
  ];
  const results = new Map();
  const conflicts = new Set();
  const fragments = text.split(/\n+|[!?]|\.(?=\s+[a-z])/);
  for (const fragment of fragments) {
    const cues = [...fragment.matchAll(/\b(?:cure|cures|cured|curing|binding\s*(?:time)?|knitting|(?:full|complete)\s+(?:setting|polymerization))\b/g)];
    if (!cues.length) continue;
    for (const pattern of patterns) {
      pattern.regex.lastIndex = 0;
      for (const match of fragment.matchAll(pattern.regex)) {
        const before = fragment.slice(0, match.index);
        const closestCue = cues.filter(cue => cue.index <= match.index).at(-1);
        const followingCue = cues.find(cue => cue.index > match.index && cue.index < match.index + match[0].length + 35);
        if ((!closestCue || match.index - closestCue.index > 220) && !followingCue) continue;
        const lastExcluded = [...before.matchAll(/\b(?:pinch(?:ing)?|bend(?:ing)?|flash|freeze|partial|tack|remov(?:al|e)|soak(?:ing)?|dissolv(?:ing|e)|dry(?:ing)?|cool(?:ing)?)\b/g)].at(-1);
        if (lastExcluded && (!closestCue || lastExcluded.index > closestCue.index)) continue;
        const context = fragment.slice(Math.max(0, (closestCue?.index ?? match.index) - 50), match.index);
        if (/\b(?:base coat|base gel|top coat|top gel|another product)\b/.test(context) && /\b(?:apply|use|recommend|layer)\b/.test(context)) continue;
        const factor = match[pattern.unit].startsWith('m') ? 60 : 1;
        const low = Math.round(Number(match[pattern.low].replace(',', '.')) * factor);
        const high = Math.round(Number((match[pattern.high] || match[pattern.low]).replace(',', '.')) * factor);
        if (low < 5 || high > 1200 || low > high) continue;
        const type = match[pattern.lamp].replace(/\s/g, '').replace('+', '/').toUpperCase();
        const value = low === high ? String(low) : low + '-' + high;
        if (results.has(type) && results.get(type) !== value) conflicts.add(type);
        results.set(type, value);
      }
    }
  }
  if (conflicts.size || (results.has('LED') && results.has('UV') && (results.has('UV/LED') || results.has('LED/UV')))) return [];
  return ['LED', 'UV', 'UV/LED', 'LED/UV'].filter(type => results.has(type)).map(type => ({ lamp: type, seconds: results.get(type), label: type + ' · ' + results.get(type).replace('-', '–') + ' SEC' }));
}

if (!customElements.get('cn-cure-details')) {
  customElements.define('cn-cure-details', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.cureReady === 'true') return;
      this.dataset.cureReady = 'true';
      const productInfo = window.document.querySelector('[id^="ProductInfo-"]');
      if (productInfo) {
        window.document.querySelectorAll('cn-cure-details.cn-product-details--beside-image').forEach(existing => {
          if (existing !== this && existing.dataset.badgeOwner === this.dataset.badgeOwner) existing.remove();
        });
        this.classList.add('cn-product-details--beside-image');
        this.setAttribute('aria-label', 'Product features and curing times');
        this.removeAttribute('aria-labelledby');
        const quantity = productInfo.querySelector('.product-form__quantity');
        const form = productInfo.querySelector('product-form');
        const anchor = quantity || form;
        if (anchor) anchor.before(this);
        else productInfo.append(this);
      }
      const grid = this.querySelector('.cn-product-details__grid');
      if (grid && productInfo) {
        const updateShade = () => {
          const colorField = Array.from(productInfo.querySelectorAll('variant-selects fieldset')).find(field => /^(?:colou?rs?|shades?)\b/i.test(field.querySelector('legend')?.textContent?.trim() || ''));
          const selectedColor = colorField?.querySelector('input:checked')?.value;
          const titleShade = productInfo.querySelector('h1[data-product-shade]')?.dataset.productShade;
          const shade = (selectedColor || this.dataset.productShade || titleShade || '').trim();
          let item = grid.querySelector('[data-shade-badge]');
          if (!shade || /\b(?:3s\d+|(?:cover\s*)?nr\.?\s*\d+)\b/i.test(shade)) {
            if (item) item.remove();
            return;
          }
          if (!item) {
            item = window.document.createElement('div');
            item.className = 'cn-product-detail';
            item.dataset.shadeBadge = 'true';
            const icon = window.document.createElement('div');
            icon.className = 'cn-product-detail__bubble';
            icon.dataset.badgeIcon = '◇';
            icon.setAttribute('aria-hidden', 'true');
            const label = window.document.createElement('p');
            label.className = 'cn-product-detail__label';
            item.append(icon, label);
            grid.prepend(item);
          }
          const label = item.querySelector('.cn-product-detail__label');
          const text = 'SHADE · ' + shade;
          if (label.textContent !== text) label.textContent = text;
          this.hidden = false;
        };
        updateShade();
        productInfo.addEventListener('change', updateShade);
        const picker = productInfo.querySelector('variant-selects');
        if (picker) {
          this.shadeObserver = new MutationObserver(updateShade);
          this.shadeObserver.observe(picker, { childList: true, subtree: true, characterData: true });
        }
      }
      if (!grid || this.dataset.autoCure !== 'true' || grid.querySelector('[data-cure-manual="true"]')) return;
      const html = (this.dataset.cureDescription || '').replace(/<\/(?:p|li|div|h[1-6])\s*>|<br\s*\/?>/gi, '\n');
      const document = new DOMParser().parseFromString(html, 'text/html');
      document.querySelectorAll('script, style, iframe, object, embed').forEach(node => node.remove());
      const badges = parseCureTimes(document.body.textContent || '');
      for (const badge of badges) {
        const item = window.document.createElement('div');
        item.className = 'cn-product-detail';
        item.dataset.autoCureBadge = badge.lamp;
        const icon = window.document.createElement('div');
        icon.className = 'cn-product-detail__bubble';
        icon.dataset.badgeIcon = '◷';
        icon.setAttribute('aria-hidden', 'true');
        const label = window.document.createElement('p');
        label.className = 'cn-product-detail__label';
        label.textContent = badge.label;
        item.append(icon, label);
        grid.append(item);
      }
      if (grid.children.length) this.hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotlight-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cn-spotlight]').forEach((section) => {
    if (section.dataset.cnSpotlightReady === 'true') return;
    section.dataset.cnSpotlightReady = 'true';

    const track = section.querySelector('[data-cn-spotlight-track]');
    const previous = section.querySelector('[data-cn-spotlight-previous]');
    const next = section.querySelector('[data-cn-spotlight-next]');

    const updateButtons = () => {
      if (!track || !previous || !next) return;
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum;
    };

    const move = (direction) => {
      if (!track) return;
      track.scrollBy({ left: track.clientWidth * 0.82 * direction, behavior: 'smooth' });
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track?.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    section.querySelectorAll('[data-cn-spotlight-card]').forEach((card) => {
      const video = card.querySelector('video');
      if (!video || reduceMotion) return;
      card.dataset.videoReady = 'true';

      const playVideo = () => {
        video.play().then(() => {
          card.dataset.videoPlaying = 'true';
        }).catch(() => {});
      };
      const stopVideo = () => {
        video.pause();
        video.currentTime = 0;
        delete card.dataset.videoPlaying;
      };

      card.addEventListener('mouseenter', playVideo);
      card.addEventListener('mouseleave', stopVideo);
      card.addEventListener('focusin', playVideo);
      card.addEventListener('focusout', stopVideo);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
